// A compact, click-to-copy identifier: shows a truncated mono id and copies the
// full value on click (with a brief check). For tables where same-named rows
// need to be told apart by id.

import { useState } from "react";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export function CopyId({ id, className }: { id: string; className?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      toast.error("Couldn't copy the id");
    }
  }

  return (
    <button
      type="button"
      onClick={() => void copy()}
      title={`Copy id: ${id}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-1.5 py-0.5 font-mono text-xs text-muted-foreground hover:bg-muted hover:text-foreground",
        className,
      )}
    >
      <span className="max-w-32 truncate">{id}</span>
      {copied ? (
        <IconCheck className="size-3.5 shrink-0 text-emerald-500" />
      ) : (
        <IconCopy className="size-3.5 shrink-0 opacity-60" />
      )}
    </button>
  );
}
